
document.addEventListener("DOMContentLoaded", function () {
    const showButtons = document.querySelectorAll(".show-popup");
    const closeButtons = document.querySelectorAll(".closer");
    const popupContainers = document.querySelectorAll(".popup-container");
    const overlap = document.querySelector(".section-overlay");
  
    showButtons.forEach((showButton, index) => {
      showButton.addEventListener("click", function () {
        const popupIndex = showButton.getAttribute("data-popup-index");
        const overlayElement = popupContainers[popupIndex];
        overlap.style.display = "block"
        overlayElement.style.display = "block";
        document.body.style.overflow = "hidden";
      });
    });
  
    closeButtons.forEach((closeButton, index) => {
      closeButton.addEventListener("click", function () {
        const popupContainer = closeButton.closest(".popup-container");
        popupContainer.style.display = "none";
        overlap.style.display = "none"
        document.body.style.overflow = "scroll";
        const iframe = popupContainer.querySelector("iframe");
        if (iframe && iframe.src.includes("youtube.com")) {
          const videoId = iframe.src.match(/embed\/([^?]+)/)[1];
          iframe.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
        }
      });
    });
  });